/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import FormGroup from "../../../common/core/FormGroup";
import Input from "../../../common/core/Input";
import Button from "../../../common/core/Button";
import Form from "../../../common/core/Form";
// import Spinner from "../../../common/core/Spinner";
import Logo from "../../../common/assets/images/fenix-logo.svg";

const ResetPassword = () => (
  <div className="login-outer">
    <div className="login-panel">
      <div className="login-brand">
        <img src={Logo} alt="" />
        <h4>Forgot Password</h4>
      </div>

      <Form>
        <fieldset>
          <FormGroup className="password">
            <Input
              value=""
              onChange=""
              type="password"
              name=""
              id=""
              placeholder="New Password"
              required
            />
            <Button color="transparent" onClick="" />
          </FormGroup>
          <FormGroup className="password">
            <Input
              value=""
              onChange=""
              type="password"
              name=""
              id=""
              placeholder="Re-Enter New Password"
              required
            />
            <Button color="transparent" onClick="" />
          </FormGroup>
          {/* <p className="text-danger mb-0 fs-xs">
              {error}
            </p> */}
          <FormGroup>
            <Button className="w-100" color="primary" block>Submit</Button>
          </FormGroup>
        </fieldset>
      </Form>
    </div>
  </div>
);

export default ResetPassword;
